function renderPrestamer () {
  return `<div class="ui-form__row hidden">
    <div class="ui-form__field vali">
      <div class="ui-checkbox-directive">
        <span class="ui-blackhole">
          <input type="checkbox" name="prestamer_agreement1" id="prestamer_agreement1" readonly="" data-required disabled="">
        </span>
        <label for="prestamer_agreement1" class="ui-checkbox new-checkbox-label">
          <div class="ui-checkbox__check">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" class="ui-icon-checkbox ui-checkbox__icon"><path stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 7s2.9 2.7 4.4 4c.4.3 1.1 1 1.1 1L16 1"></path></svg>
          </div>
          <span class="ui-checkbox__text-wrapper">He leído, entiendo y acepto las 
            <a class="msf lh-big" target="_blank" href="https://prestamer.es/how-to-take/loan-rules">condiciones generales de contratación del préstamo</a>
            la
            <a class="msf lh-big" target="_blank" href="https://prestamer.es/how-to-take/personal-data-rules">política de privacidad y protección de datos personales</a>
            <a class="msf lh-big" target="_blank" href="https://prestamer.es/how-to-take/agreement">y la política de cookies.</a>.
          </span>
        </label>
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Tiene que aceptar las condiciones</div>
    </div>
    <div class="ui-form__field vali">
      <div class="ui-checkbox-directive">
        <span class="ui-blackhole">
          <input type="checkbox" name="prestamer_agreement2" id="prestamer_agreement2" readonly="" data-required disabled="">
        </span>
        <label for="prestamer_agreement2" class="ui-checkbox new-checkbox-label">
          <div class="ui-checkbox__check">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" class="ui-icon-checkbox ui-checkbox__icon"><path stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 7s2.9 2.7 4.4 4c.4.3 1.1 1 1.1 1L16 1"></path></svg>
          </div>
          <span class="ui-checkbox__text-wrapper">
            <span class="">Mediante la marcación de esta casilla, consiento explícita e inequívocamente el tratamiento de mis datos personales por PRESTAMER, incluida la transferencia internacional de mis datos y la elaboración de un perfil basado en mi comportamiento económico, que será objeto de decisiones automatizadas. Confirmo que soy mayor de 21 años.</span>
          </span>
        </label>
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Tiene que aceptar las condiciones</div>
    </div>
  </div>`
}

export { renderPrestamer }